import { apiHost } from './api-host'

let loaded = {}

const loadTags = async (files) => {
  for (let idx in files) {
    const file = files[idx]
    if (file.url.startsWith('file')) {
      file.key = file.url.split('file:')[1]
      file.url = file.url.replace('file:', `${apiHost}/s3/`)
    }
    await new Promise(res => {
      switch (file.type) {
        case 'style':
          var link = document.createElement('link')
          link.rel = 'stylesheet'
          link.href = file.url
          document.head.appendChild(link)
          loaded[file.url] = true
          res()
          break
        case 'script':
          var scriptTag = document.createElement('script')
          scriptTag.onload = res
          scriptTag.type = 'text/javascript'
          scriptTag.src = file.url
          document.head.appendChild(scriptTag)
          loaded[file.url] = true
          break
        case 'image':
          // Store image URL in window.static object
          if (!window.static) {
            window.static = {}
          }
          window.static[file.key] = file.url
          loaded[file.url] = true
          res()
          break
        case 'video':
          // Store video URL in window.static object
          if (!window.static) {
            window.static = {}
          }
          window.static[file.key] = file.url
          loaded[file.url] = true
          res()
          break
        default:
          break
      }
    })
  }
}

const loadExtFiles = async (files) => {
  await loadTags(files.sort((f1, f2) => {
    return +f1.order - f2.order
  }))
}

export default loadExtFiles
